<!--
 * @Author: xuchen
 * @Date: 2020-05-25 11:10:17
 * @Desc: 视频回放弹窗
-->
<template>
  <el-dialog
    title="视频回放"
    :visible="visible"
    :before-close="handleBeforeClose"
    :area="700"
    top="middle"
    :custom-class="modelClass"
    @close="handleClose"
    @opened="handleOpened"
  >
    <div v-if="visible" style="height: 540px;">
      <PlayBackOcx
        ref="playBackOcxRef"
        :scroll-el="scrollEl"
        :params="videoParams"
        :toolbar="true"
      />
    </div>
  </el-dialog>
</template>

<script>
import PlayBackOcx from '@/components/VideoOcx/PlayBackOcx.vue'
import http from '@/api/common.api'

let count = 1

export default {
  name: 'PlayBackVideoDialog',
  components: {
    PlayBackOcx
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },

    // 请求参数
    payload: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      videoParams: {}, // 预览视频的播放参数
      scrollEl: null, // 弹窗遮罩对象
      modelClass: '' // 弹窗class
    }
  },
  watch: {
    visible(data) {
      if (data) {
        this.getVideoParams()
      }
    }
  },
  created() {
    count += 1
    this.modelClass = `model-${count}-${Date.now()}`
  },
  methods: {
    handleOpened() {
      !this.scrollEl &&
        this.$nextTick(() => {
          this.scrollEl = document.querySelector(`.${this.modelClass}`).parentNode
        })
    },
    /**
     * @author xuchen
     * @date 2020-05-25 11:27:14
     * @desc 获取视频参数
     */
    async getVideoParams() {
      const { data } = await http.getPlaybackVideoParams(this.payload)
      this.videoParams = data
    },

    /**
     * @author xuchen
     * @date 2020-05-29 10:07:52
     * @desc 关闭弹窗前的回调
     */
    handleBeforeClose(done) {
      this.$refs.playBackOcxRef && this.$refs.playBackOcxRef.closeVideo()
      // this.$refs.playBackOcxRef.destroyed()
      done()
    },

    /**
     * @author xuchen
     * @date 2020-05-29 10:08:05
     * @desc 关闭弹窗
     */
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    padding: 0;
  }
}
</style>
